let textArray = [
  "吉",
  "祥",
  "如",
  "意",
  "风",
  "调",
  "雨",
  "顺",
  "五",
  "谷",
  "丰",
  "登",
  "人",
  "寿",
  "年",
  "凤",
  "鸣",
  "朝",
  "阳",
  "板",
  "桥",
  "幽",
  "竹",
  "气",
  "若",
  "兰",
  "泽",
  "时",
  "澄",
  "心",
  "清",
  "神",
  "怡",
  "然",
  "自",
  "乐",
  "鹤",
  "九",
  "皋",
  "云",
  "兴",
  "霞",
  "蔚",
  "百",
  "川",
  "归",
  "海",
  "春",
  "和",
  "贻",
  "荡",
  "卉",
  "含",
  "英",
  "枕",
  "流",
  "漱",
  "石",
  "飞",
  "鱼",
  "跃",
  "冰",
  "壶",
  "秋",
  "月",
  "日",
  "暄",
  "山",
  "浓",
  "艳",
  "秀",
  "菊",
  "芳",
  "鸾",
  "翔",
  "集",
  "赫",
  "辉",
  "龙",
  "藏",
  "深",
  "泉",
  "松",
  "韵",
  "绿",
  "静",
  "蕙",
  "桂",
  "馥",
  "福",
  "东",
  "比",
  "南",
  "泰",
  "安",
  "浮",
  "翠",
  "丹",
  "花",
  "情",
];

export {
  textArray
}